import {UserRoles, roles} from '../../utils/roles';

export interface ISidebarData {
  routeLink: string | null;
  imgSrc: string;
  text: string;
  allowedGroups: string[];
  display?: boolean;
}

export const sidebarDisplayData: ISidebarData[] = [
  {
    routeLink: '/employee',
    imgSrc: 'employees.svg',
    text: 'Employees',
    allowedGroups: roles.ALLOWED_ALL,
  },
  // Temporary commented
  // {
  //   routeLink: '/interviews',
  //   imgSrc: 'interview.svg',
  //   text: 'Interviews',
  //   allowedGroups: [
  //     ...roles.RECRUITMENT_DEPARTMENT,
  //     ...roles.CEO,
  //     ...roles.HR_DEPARTMENT,
  //   ],
  // },
  {
    routeLink: '/time-logs',
    imgSrc: 'anuko.svg',
    text: 'Time logs',
    allowedGroups: [...roles.ACCOUNTANT_DEPARTMENT, ...roles.CEO],
  },
  {
    routeLink: '/salary',
    imgSrc: 'salary.svg',
    text: 'Salary',
    allowedGroups: [...roles.ACCOUNTANT_DEPARTMENT, ...roles.CEO],
  },
  {
    routeLink: '/system-logs',
    imgSrc: 'logs.svg',
    text: 'Logs',
    allowedGroups: [
      ...roles.ALL_DEPARTMENTS_HEADS,
      ...roles.DELIVERY_MANAGEMENT,
      ...roles.CEO,
    ],
  },
  {
    routeLink: '/notifications',
    imgSrc: 'notifications.svg',
    text: 'Notifications',
    allowedGroups: [
      ...roles.HR_DEPARTMENT,
      ...roles.ACCOUNTANT_DEPARTMENT,
      ...roles.CEO,
      ...roles.DELIVERY_DEPARTMENT,
      ...roles.LINE_MANAGEMENT,
      ...roles.ADMIN,
    ],
  },
  {
    routeLink: 'audit',
    imgSrc: 'audit.svg',
    text: 'Audit',
    allowedGroups: roles.ADMIN,
  },
  {
    routeLink: '/settings',
    imgSrc: 'settings.svg',
    text: 'Settings',
    allowedGroups: [
      ...roles.CEO,
      ...roles.HR_DEPARTMENT,
      ...roles.ACCOUNTANT_DEPARTMENT,
      ...roles.DELIVERY_DEPARTMENT,
      UserRoles.headOfRecruitment,
      UserRoles.leadOfRecruitment,
    ],
  },
  {
    routeLink: '/events',
    imgSrc: 'events.svg',
    text: 'Events',
    allowedGroups: [...roles.CEO, ...roles.HR_DEPARTMENT],
  },
  {
    routeLink: '/roles',
    imgSrc: 'roles.svg',
    text: 'Roles',
    allowedGroups: [...roles.CEO, ...roles.ADMIN],
  },
  {
    routeLink: '/bcoins',
    imgSrc: 'bcoin.svg',
    text: 'B-сoin',
    allowedGroups: [...roles.CEO, ...roles.HR_DEPARTMENT],
  },
];
